module.exports = __webpack_public_path__ + "static_pc/img/beian.d0289dc0.png";